module.exports = __webpack_public_path__ + "img/phon3-lookme.b0e4b495.png";